import React from 'react';
import SearchIcon from "assets/images/images_new/zoom-lens.png";

export default function SearchFilter({
	search, handleSearchChange, clickSearch
}) {
const submitHandler=(e)=>
{
	e.preventDefault();
	clickSearch();
}

	return (
			<div className="searchkeywords searchkeywords-wrapper">
				<form onSubmit={submitHandler}>
			 		<input
					className="searchkeywordsinput"
					type="text"
					name="search"
					placeholder="Search keywords"
					autoComplete="off"
					value={search}
					onChange={handleSearchChange}
					/> 
					<button className="searchkeywords-btn">
						<img
							src={SearchIcon}
							alt="Search Image"
						/>
					</button>
			    </form>
		   </div>
	);
}